






















































































import {Component, Prop, Vue} from 'vue-property-decorator';
import Button from '@/components/commons/Button.vue';
import Meter from '@/data/models/meter';
import MeterReading from "@/data/models/meter-reading";

@Component({components: {Button}})
export default class MeterCard extends Vue {
  @Prop({required: true})
  meter: Meter;

  @Prop({required: true})
  update;

  @Prop({required: true})
  see;

  @Prop({required: true})
  displaySee: boolean;

  @Prop({required: true})
  clone;

  @Prop({required: true})
  download;

  lastValue: MeterReading = null;

  refreshInterval: any = null;

  mounted(): void {
    this.getValue();

    this.refreshInterval = setInterval(() => {
      this.getValue();
    }, 60000);
  }

  beforeDestroy(): void {
    clearInterval(this.refreshInterval);
  }

  getValue(): void {
    this.$dao.meters.getLastValue(this.meter.id).then(value => this.lastValue = value);
  }
}
